import { PAYMENT_URL } from "../constants";

export type CheckoutPlan = "growth" | "professional";
export type CheckoutInterval = "monthly" | "quarterly" | "yearly";
export type CheckoutResponse =
  | { mode: "checkout"; url: string }
  | {
      mode: "scheduled";
      message?: string;
      pendingPlanChange?: {
        targetPlanKey: string;
        targetInterval: string;
        targetSeatCount?: number | null;
        effectiveAt: string;
        status: string;
      };
    }
  | {
      mode: "activated";
      message?: string;
      trialEndDate?: string;
      plan?: {
        planKey: string;
        interval: string;
        seatCount?: number;
        trialEndDate?: string;
      };
    };

export async function createCheckoutSession(params: {
  ownerId?: string;
  userId?: string;
  plan: CheckoutPlan;
  interval: CheckoutInterval;
  trial: boolean;
  seatCount?: number;
}): Promise<CheckoutResponse> {
  const resp = await fetch(`${PAYMENT_URL}/createCheckoutSession`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  });
  const data = await resp.json();
  if (!resp.ok) {
    throw new Error(data?.error || "Unable to start checkout session");
  }
  if (data?.mode === "scheduled") {
    return {
      mode: "scheduled",
      message: data?.message,
      pendingPlanChange: data?.pendingPlanChange,
    };
  }
  if (data?.mode === "activated") {
    return {
      mode: "activated",
      message: data?.message,
      trialEndDate: data?.plan?.trialEndDate,
      plan: data?.plan,
    };
  }
  if (!data?.url) throw new Error("Checkout URL not returned by server");
  return { mode: "checkout", url: data.url as string };
}

export function getActivatedTrialMessage(
  result: Extract<CheckoutResponse, { mode: "activated" }>,
  launchTrialLabel = "7-day free trial"
) {
  return (
    result.message ||
    `Your ${launchTrialLabel} is active.`
  );
}
